import moment from "moment-timezone";
import {
  DEFAULT_TIME_ZONE,
  STANDARD_DATE_FORMAT,
  TEXTUAL_DATE_FORMAT,
} from "../Constants/date";
import DateConverter from "@remotemerge/nepali-date-converter";

export const formatDateBasedOnTimezone = ({
  date,
  timezone = DEFAULT_TIME_ZONE,
  formatType = TEXTUAL_DATE_FORMAT,
}: {
  date: any;
  timezone?: string;
  formatType?: string;
}) => {
  if (!date) return "";
  return moment(date).tz(timezone).format(formatType);
};

export const convertADToBS = (date: string) => {
  if (!date) return "";

  const formatteDate = formatDateBasedOnTimezone({
    date,
    formatType: STANDARD_DATE_FORMAT,
  });

  const adToBs = new DateConverter(formatteDate).toBs();

  const bsDateFormatted = `${adToBs.year}-${String(adToBs.month).padStart(
    2,
    "0"
  )}-${String(adToBs.date).padStart(2, "0")}`;

  // return in YYYY-MM-DD format

  return bsDateFormatted;
};
